import { useRef, useCallback } from 'react';
import getNestedProp from '../../../get-nested-prop';
import isEqual from 'lodash/isEqual';

/**
 * @description Retorna un objeto que representa a las props, pero que solo se actualiza si cambian las dependencias definidas en los plugins.
 * @param {Array} plugins - Lista de plugins.
 * @param {Object} props - Props del componente.
 * @returns {Object} - Fuente de verdad para determinar si matchean los plugins.
 */
const useSource = (plugins, props) => {
  const ref = useRef(null);

  const getDepsProps = useCallback(
    () =>
      plugins.reduce((acc, plugin) => {
        const deps = plugin.deps || [];
        return {
          ...acc,
          ...deps.reduce((acc2, str) => {
            const value = getNestedProp(props, str);
            return { ...acc2, [str]: value };
          }, {}),
        };
      }, {}),
    [props, plugins],
  );

  if (ref.current === null) {
    ref.current = {};
    ref.current.depsProps = getDepsProps();
    ref.current.source = props;
  }

  const depsProps = getDepsProps();

  if (!isEqual(ref.current.depsProps, depsProps)) {
    ref.current.depsProps = depsProps;
    ref.current.source = props;
  }

  return ref?.current?.source;
};

export default useSource;
